import Seasons from './Seasons';

export default Seasons;
